import {http} from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    getTenantInvitations() {
        return http.get('/api/v1/admin/tenants/invitations');
    },

    storeTenantInvitation(email) {
        return http.post('/api/v1/admin/tenants/invite', {
            email: email,
            status: 'sent'
        });
    },

    revokeInvitation(invitationKey) {
        return http.post(`/api/v1/admin/tenants/revoke/${invitationKey}`).then(getData);
    },

    submitRegistrationForm(invitationKey, params) {
        return http.post(`/api/registration/submit-tenant-form/${invitationKey}`, params).then(getData);
    },

    approveInvitation(invitationKey, params) {
        return http.post(`/api/v1/admin/tenants/approve/${invitationKey}`, params).then(getData);
    },

    rejectInvitation(invitationKey, params) {
        return http.post(`/api/v1/admin/tenants/reject/${invitationKey}`, params).then(getData);
    }
};



// WEBPACK FOOTER //
// ./src/services/Tenants/TenantInvitationController.js